<section class="phs-tcheat">
  <e-card2 class="phs-tcheat__controls-card" padding="2">
    <div class="phs-tcheat__controls" aria-label="PHS cheat sheet controls">

      <!-- Taalkeuze (zelfde patroon als de andere cheat sheets) -->
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="phs-tcheat__divider"></span>

      <!-- Print (analoog aan de andere controls-bar controls) -->
      <button type="button" class="phs-tcheat__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  <div class="phs-tcheat__deck">
    @for (cat of bands; track cat) {
      <hd-phs-transformation-band [category]="cat" />
    }
  </div>
</section>
